exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plugin-container[data-v-04365d9e] {\n  background-color: #f8f8f8;\n}\n.block-plugin[data-v-04365d9e] {\n  position: sticky;\n  top: 0;\n  z-index: 99;\n}\n.plugin-video[data-v-04365d9e] {\n  width: 679px;\n  max-width: 100%;\n}", ""]);

// exports
